import { TranslationKey, translationKey, unsafeTranslationKey } from 'intl/types/translationKey';
import { WorkflowStageIcon } from 'shared/domain/workflow/types';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const WorkflowTranslationKeys = {
  decisionApprovedOnStage: translationKey('decision_approved_on_stage'),
  decisionRejectedOnStage: translationKey('decision_rejected_on_stage'),
  dialogApprove: translationKey('event_dialog_approve'),
  dialogDecisionSectionTitle: translationKey('event_dialog_decision_section_title'),
  dialogMessageOnly: translationKey('event_dialog_message_only'),
  dialogReject: translationKey('event_dialog_reject'),
  dialogSelectStage: translationKey('event_dialog_select_stage'),
  stageAwaitingApprovals: translationKey('stage_awaiting_approvals'),
  stageRejected: translationKey('stage_rejected'),
  workflow: translationKey('workflow'),
  approvalMode: translationKey('workflow_approval_mode'),
  approvalScheme: translationKey('workflow_approval_scheme'),
  approvalStatus: translationKey('workflow_approval_status'),
  approve: translationKey('workflow_approve'),
  approved: translationKey('workflow_approved'),
  approver: translationKey('workflow_approver'),
  configurationApproversOrderParallelInfo: translationKey('workflow_configuration_approvers_order_parallel_info'),
  configurationApproversOrderSequentialInfo: translationKey('workflow_configuration_approvers_order_sequential_info'),
  configurationCreateButton: translationKey('workflow_configuration_create_button'),
  configurationDialogCreateTitle: translationKey('workflow_configuration_dialog_create_title'),
  configurationDialogEditTitle: translationKey('workflow_configuration_dialog_edit_title'),
  configurationEditAria: translationKey('workflow_configuration_edit_aria'),
  configurationEmptyState: translationKey('workflow_configuration_empty_state'),
  configurationInUseChip: translationKey('workflow_configuration_in_use_chip'),
  configurationLastApproverDeleteTooltip: translationKey('workflow_configuration_last_approver_delete_tooltip'),
  configurationLockedChip: translationKey('workflow_configuration_locked_chip'),
  configurationNameLabel: translationKey('workflow_configuration_name_label'),
  configurationPageTitle: translationKey('workflow_configuration_page_title'),
  configurationParallelChip: translationKey('workflow_configuration_parallel_chip'),
  configurationSequentialChip: translationKey('workflow_configuration_sequential_chip'),
  configurationStageAdd: translationKey('workflow_configuration_stage_add'),
  configurationStageAddApproverLabel: translationKey('workflow_configuration_stage_add_approver_label'),
  configurationStageAddApproverPlaceholder: translationKey('workflow_configuration_stage_add_approver_placeholder'),
  configurationStageApprovalTypeLabel: translationKey('workflow_configuration_stage_approval_type_label'),
  configurationStageApproversLabel: translationKey('workflow_configuration_stage_approvers_label'),
  configurationStageDeadlineDaysLabel: translationKey('workflow_configuration_stage_deadline_days_label'),
  configurationStageDeadlineInvalid: translationKey('workflow_configuration_stage_deadline_invalid'),
  configurationStageDeleteAria: translationKey('workflow_configuration_stage_delete_aria'),
  configurationStageDeleteMessage: translationKey('workflow_configuration_stage_delete_message'),
  configurationStageDeleteTitle: translationKey('workflow_configuration_stage_delete_title'),
  configurationStageDialogCreateTitle: translationKey('workflow_configuration_stage_dialog_create_title'),
  configurationStageDialogEditTitle: translationKey('workflow_configuration_stage_dialog_edit_title'),
  configurationStageEditAria: translationKey('workflow_configuration_stage_edit_aria'),
  configurationStageIconLabel: translationKey('workflow_configuration_stage_icon_label'),
  configurationStageNameLabel: translationKey('workflow_configuration_stage_name_label'),
  configurationStagesChip: translationKey('workflow_configuration_stages_chip'),
  configurationStagesEmpty: translationKey('workflow_configuration_stages_empty'),
  configurationStagesSectionTitle: translationKey('workflow_configuration_stages_section_title'),
  configurationViewAria: translationKey('workflow_configuration_view_aria'),
  creatorAddApprover: translationKey('workflow_creator_add_approver'),
  creatorAddStage: translationKey('workflow_creator_add_stage'),
  creatorApprovalEnabled: translationKey('workflow_creator_approval_enabled'),
  creatorApprovalParallelHint: translationKey('workflow_creator_approval_parallel_hint'),
  creatorApprovalSequentialHint: translationKey('workflow_creator_approval_sequential_hint'),
  creatorApprovalType: translationKey('workflow_creator_approval_type'),
  creatorApprovers: translationKey('workflow_creator_approvers'),
  creatorApproversOrderHint: translationKey('workflow_creator_approvers_order_hint'),
  creatorApproversSequential: translationKey('workflow_creator_approvers_sequential'),
  creatorAutoApprove: translationKey('workflow_creator_auto_approve'),
  creatorAutoApproveDesc: translationKey('workflow_creator_auto_approve_desc'),
  creatorAutoApproveStage: translationKey('workflow_creator_auto_approve_stage'),
  creatorBasicInfoDescription: translationKey('workflow_creator_basic_info_description'),
  creatorBasicInfoTitle: translationKey('workflow_creator_basic_info_title'),
  creatorDeadlineDays: translationKey('workflow_creator_deadline_days'),
  creatorDeadlineDaysPlaceholder: translationKey('workflow_creator_deadline_days_placeholder'),
  creatorDeleteStage: translationKey('workflow_creator_delete_stage'),
  creatorEditStage: translationKey('workflow_creator_edit_stage'),
  creatorEnableApproval: translationKey('workflow_creator_enable_approval'),
  creatorLockedBanner: translationKey('workflow_creator_locked_banner'),
  creatorNewStageHeading: translationKey('workflow_creator_new_stage_heading'),
  creatorNoApproval: translationKey('workflow_creator_no_approval'),
  creatorPreview: translationKey('workflow_creator_preview'),
  creatorRequiredApprovalsLabel: translationKey('workflow_creator_required_approvals_label'),
  creatorRequiredApprovalsOfTotal: translationKey('workflow_creator_required_approvals_of_total'),
  creatorSave: translationKey('workflow_creator_save'),
  creatorStageDescription: translationKey('workflow_creator_stage_description'),
  creatorStageDescriptionPlaceholder: translationKey('workflow_creator_stage_description_placeholder'),
  creatorStageDetails: translationKey('workflow_creator_stage_details'),
  creatorStageName: translationKey('workflow_creator_stage_name'),
  creatorStageNameRequired: translationKey('workflow_creator_stage_name_required'),
  creatorStageNoApproval: translationKey('workflow_creator_stage_no_approval'),
  creatorStageNoApprovalDesc: translationKey('workflow_creator_stage_no_approval_desc'),
  creatorStageNoApprovalTitle: translationKey('workflow_creator_stage_no_approval_title'),
  creatorStageNumber: translationKey('workflow_creator_stage_number'),
  creatorStageType: translationKey('workflow_creator_stage_type'),
  creatorStagesApprovalNotice: translationKey('workflow_creator_stages_approval_notice'),
  creatorStagesDescription: translationKey('workflow_creator_stages_description'),
  creatorStagesDescriptionLockedNoApprovers: translationKey('workflow_creator_stages_description_locked_no_approvers'),
  creatorStagesDescriptionLockedWithApprovers: translationKey('workflow_creator_stages_description_locked_with_approvers'),
  creatorStagesTitle: translationKey('workflow_creator_stages_title'),
  creatorTitle: translationKey('workflow_creator_title'),
  decision: translationKey('workflow_decision'),
  decisionApproved: translationKey('workflow_decision_approved'),
  decisionComment: translationKey('workflow_decision_comment'),
  decisionCommentRequired: translationKey('workflow_decision_comment_required'),
  decisionCreateFailed: translationKey('workflow_decision_create_failed'),
  decisionIssuedAt: translationKey('workflow_decision_issued_at'),
  decisionRejected: translationKey('workflow_decision_rejected'),
  loading: translationKey('workflow_loading'),
  makeDecision: translationKey('workflow_make_decision'),
  makeNewDecision: translationKey('workflow_make_new_decision'),
  name: translationKey('workflow_name'),
  noAccess: translationKey('workflow_no_access'),
  notAvailable: translationKey('workflow_not_available'),
  parallelApproval: translationKey('workflow_parallel_approval'),
  previousApproverNoDecision: translationKey('workflow_previous_approver_no_decision'),
  previousApproverRejected: translationKey('workflow_previous_approver_rejected'),
  previousDecisionsHide: translationKey('workflow_previous_decisions_hide'),
  previousDecisionsShow: translationKey('workflow_previous_decisions_show'),
  reject: translationKey('workflow_reject'),
  rejected: translationKey('workflow_rejected'),
  rejectionRequiresComment: translationKey('workflow_rejection_requires_comment'),
  saveConfirmDescription: translationKey('workflow_save_confirm_description'),
  saveConfirmDescriptionWithProcesses: translationKey('workflow_save_confirm_description_with_processes'),
  saveConfirmNoProcesses: translationKey('workflow_save_confirm_no_processes'),
  saveConfirmTitle: translationKey('workflow_save_confirm_title'),
  saveFailedPhase: translationKey('workflow_save_failed_phase'),
  sequentialApproval: translationKey('workflow_sequential_approval'),
  stage: translationKey('workflow_stage'),
  stageApprovalNone: translationKey('workflow_stage_approval_none'),
  stageApprovalParallel: translationKey('workflow_stage_approval_parallel'),
  stageApprovalRequired: translationKey('workflow_stage_approval_required'),
  stageApprovalSequential: translationKey('workflow_stage_approval_sequential'),
  stageChangeInvalid: translationKey('workflow_stage_change_invalid'),
  stageIconAssignment: translationKey('workflow_stage_icon_assignment'),
  stageIconBugReport: translationKey('workflow_stage_icon_bugReport'),
  stageIconBuild: translationKey('workflow_stage_icon_build'),
  stageIconCheckCircle: translationKey('workflow_stage_icon_checkCircle'),
  stageIconConstruction: translationKey('workflow_stage_icon_construction'),
  stageIconDescription: translationKey('workflow_stage_icon_description'),
  stageIconEngineering: translationKey('workflow_stage_icon_engineering'),
  stageIconInfo: translationKey('workflow_stage_icon_info'),
  stageIconInventory: translationKey('workflow_stage_icon_inventory'),
  stageIconLocalShipping: translationKey('workflow_stage_icon_localShipping'),
  stageIconOrderNumber: translationKey('workflow_stage_icon_order_number'),
  stageIconSecurity: translationKey('workflow_stage_icon_security'),
  stageName: translationKey('workflow_stage_name'),
  stageRejected2: translationKey('workflow_stage_rejected'),
  stepperRequiredDecisionsSummary: translationKey('workflow_stepper_required_decisions_summary'),
  waitingForDecision: translationKey('workflow_waiting_for_decision'),
} as const satisfies Record<string, TranslationKey>;

export function workflowStageIconKey(icon: WorkflowStageIcon): TranslationKey {

  return unsafeTranslationKey(`workflow_stage_icon_${icon}`);

}
